import { post, get } from './http';

// 通过手机号获取token
export const login = (params) =>
	post(
		'/sso/login/pc/token',
		params,
		localStorage.getItem('env') ? { env: localStorage.getItem('env') } : { 'Content-Type': 'application/json' }
	);
// export const getUserRoleFuncMenus = (params) => post('/wapc/role/getUserRoleFuncMenus', params)
// 发送验证码
export const sendTextCode = (params) => get('/sso/login/pc/sendTextCode', params);
// 校验验证码
export const checkCode = (params) => get('/wapc/send/checkCode', params);
// 通过token 获取登录信息
export const getUserLoginInfo = (params) => get('/sso/login/pc/getUserLoginInfo', params);

export const getBannerMstrs = (params) => post('/wapc/bannerMstr/getBannerMstrs', params);

export const getExtUserTokenNotSign = (params) => get('/sso/login/pc/getExtUserTokenNotSign', params);

export const checkLoginUserIsExist = (params) => post('/sso/login/pc/checkLoginUserIsExist', params);

// 接入钉钉
export const dingdingLogin = (params) => post('/sso/login/app/dingdingLogin', params);

// 微信登录
export const tokenByWeChat = (params) =>
	post(
		'/sso/login/pc/tokenByWeChat',
		params,
		localStorage.getItem('env') ? { env: localStorage.getItem('env') } : { 'Content-Type': 'application/json' }
	);
// 通过ordId 获取登录平台类型
export const getOrgnization = (params) => get('/sso/login/pc/tokenByWeChat', getOrgnization);

// 平台端登录
export const tokenToPlatform = (params) => post('/sso/login/pc/tokenToPlatform', params);
// 数据字典
export const listDataDic = (params) => get('/wapc/dic/listDataDic', params);
